import { Button, Card, Checkbox, Modal, StatusBadge, Tooltip } from "@forge/common";
import { useAuth } from "../../../../../common/hooks/useAuth";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import DuplicateCourse from "../../common/components/duplicate-course/duplicateCourse";
import courseiconImg from '../../../../../common/assets/course-icon.svg';
import deleteIconImg from '../../../../../common/assets/delete.svg';
import eyeIconImg from '../../../../../common/assets/eye.svg';
import copyIconImg from '../../../../../common/assets/copy.svg';
import editIconImg from '../../../../../common/assets/edit.svg';
import { VIEW_COURSE } from "../utils/constants";
import { formatDate } from "../../../../../common/utility/plantDetailUtils";
import "./view-course-detail-card.scss";
import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCourseTemplate, getCourseViewTemplate, deleteCourseInstance, getCourseInstanceViewTemplate, getCardCourseCount } from "../store/view-course-template.action";
import { AppState } from "../../../../../common/store/combinedReducer";
import { REQUIRED_PERMISSIONS } from "../../../../../common/authentication/config";
import { btnResponsive, textResponsive } from "../../common/utils/helper";
import ButtonComponent from "../../common/components/button/button";
import { showToast } from "../../store/model/model.action";

// Wrapper component to prevent monochrome prop from being passed to img
const IconWrapper = ({ src, alt, ...props }: { src: string; alt: string;[key: string]: any }) => {
  const { monochrome, ...imgProps } = props;
  return <img src={src} alt={alt} {...imgProps} />;
};

const ViewCourseDetail = (props: any) => {
  const { hasPermission } = useAuth();
  const navigate = useNavigate();
  const [showCopyCourseModal, setShowCopyCourseModal] = useState<boolean>(false);
  const [modalcourseId, setModalcourseId] = useState<string>('');
  const [courseDataWithProgress, setCourseDataWithProgress] = useState<any[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedCourse, setSelectedCourse] = useState<any>(null);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [showCourseInstanceDeleteModal, setShowCourseInstanceDeleteModal] = useState(false);

  const dispatch = useDispatch();

  const { deleteCourseTemplateData } = useSelector((state: AppState) => {
    return state.viewCourseTemplateReducer;
  })

  const { deleteCourseInstanceData } = useSelector((state: AppState) => {
    return state.viewCourseTemplateReducer;
  })

  const onItemSelect = (data: string, isChecked: boolean) => {
    if (isChecked) {
      if (!props.selectedItems.includes(data)) {
        props.setSelectedItems([...props.selectedItems, data]);
      }
    } else {
      props.setSelectedItems(props.selectedItems.filter((item: any) => item !== data));
    }
  };

  useEffect(() => {
    if (Array.isArray(props.courseData)) {
      if (props.selectedCard === 3) {
        setCourseDataWithProgress(props.courseData);
      }
      else {
        const updated = props.courseData.map((course: any) => {
          if (!course) return course;
          return {
            ...course,
            inProgressStatus: [0, 1, 2, 6, 13, 16, 17].includes(course.courseStage),
            failedStatus: [7, 8, 9, 10, 11, 12].includes(course.courseStage),
            // Ensure courseId is available by mapping from CourseID if needed
            courseId: course.courseId || course.CourseID || course.courseDefintionID
          };
        });
        setCourseDataWithProgress(updated);
      }
    }
  }, [props.courseData]);

  useEffect(() => {
    if (deleteCourseTemplateData && isDeleting) {
      if (deleteCourseTemplateData.status === 200) {
        dispatch(showToast({ type: 'success', content: deleteCourseTemplateData.message }));
        if (props.selectedCard !== 3) {
          dispatch(getCourseViewTemplate({ pageNumber: 1, pageSize: 15 ,courseStage: props.selectedCard === 0 ? "" : props.selectedCard === 1 ? "Published" : "Draft" }));
        }
        // Refresh count cards
        dispatch(getCardCourseCount());
      } else {
        dispatch(showToast({ type: 'error', content: deleteCourseTemplateData.message }));
      }
      setIsDeleting(false);
    }
  }, [deleteCourseTemplateData, isDeleting]);

  useEffect(() => {
    if (deleteCourseInstanceData && isDeleting) {
      if (deleteCourseInstanceData.status === 200) {
        dispatch(showToast({ type: 'success', content: deleteCourseInstanceData.message }));
        dispatch(getCourseInstanceViewTemplate({ pageNumber: 1, pageSize: 15 }));
        // Refresh count cards
        dispatch(getCardCourseCount());
      } else {
        dispatch(showToast({ type: 'error', content: deleteCourseInstanceData.message }));
      }
      setIsDeleting(false);
    }
  }, [deleteCourseInstanceData, isDeleting]);

  // const handleDuplicateClick = (courseId: string) => {
  //   setModalcourseId(courseId);
  //   setShowCopyCourseModal(true);
  // };

  const handleCloseModal = () => {
    setShowCopyCourseModal(false);
    setModalcourseId('');
  };

  const handleDeleteClick = (courseId: string, course: any) => {
    if (props.selectedCard === 3 && courseId) {
      setModalcourseId(courseId);
      setSelectedCourse(course);
      setShowCourseInstanceDeleteModal(true);
    } else if (courseId) {
      setModalcourseId(courseId);
      setSelectedCourse(course);
      setShowDeleteModal(true);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setModalcourseId('');
    setSelectedCourse(null);
  };

  const handleDeleteCourse = () => {
    setIsDeleting(true);
    handleCloseDeleteModal();
    dispatch(deleteCourseTemplate([Number(modalcourseId)]));
  };

  const handleCourseInstanceDeleteConfirm = () => {
    setIsDeleting(true);
    handleDeleteCancel();
    dispatch(deleteCourseInstance([String(modalcourseId)]));
  };

  const handleDeleteCancel = () => {
    setShowCourseInstanceDeleteModal(false);
    setModalcourseId('');
    setSelectedCourse(null);
  };

  return (
    <>
      <div className="card-detail overflow-y-auto" role="region">
        <div className="card-detail-row">
          {Array?.isArray(courseDataWithProgress) && courseDataWithProgress?.map((course: any, idx: number) => {
            if (!course) return null;
            const courseId = course?.courseId || `course-${idx}`;
            // For deployed course instances (selectedCard === 3), treat status 0 as expired (not selectable)
            const isInstanceView = props.selectedCard === 3;
            const isInactiveInstance = isInstanceView && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4); // includes expired (0), in-progress (2), failed (3), deletion in-progress (4)
            return (
              <Card
                key={course?.courseId}
                className={`flex-col card-courses-detail !shadow-none flex-1 basis-0 !rounded-none justify-between !p-5 !h-auto`}
              >
                <div className="flex items-start justify-between">
                  <div className={`flex items-start gap-2 flex-1 w-1/2 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ? " opacity-50" : ""}`}>
                    <img src={courseiconImg} alt="Course Icon" className="course-icon" />
                    {props.selectedCard === 3 ?
                      <div>
                        {(course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4) ?
                          <p className={`${textResponsive("text-base")} font-semibold individual-course xl-mid:mb-2 xl-low:mb-1 mb-1 xl-high:mb-3 w-[200px] xl-low:w-[240px] xl-mid:w-[300px] xl-high:w-[230px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                            {course.courseName}
                          </p>
                          :
                          <Tooltip content={course.courseName} position="bottom-left">
                            <p className={`${textResponsive("text-base")} font-semibold individual-course xl-mid:mb-2 xl-low:mb-1 mb-1 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus ? props.selectedCard === 3 ? "xl-low:w-[350px] w-[280px] xl-mid:w-[350px] xl-high:w-[400px]" : "xl-low:w-[310px] w-[250px] xl-mid:w-[300px] xl-high:w-[250px]" : "xl-low:w-[350px] w-[280px] xl-mid:w-[430x] xl-high:w-[400px]"} truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                              {course.courseName}
                            </p>
                          </Tooltip>
                        }
                        {(course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4) ?
                          <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap xl-high:mb-3 w-[200px] xl-low:w-[240px] xl-mid:w-[300px] xl-high:w-[230px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                            {course.courseDescription ? course.courseDescription : "--"}
                          </p>
                          :
                          course.courseDescription ?
                          <Tooltip content={course.courseDescription?.length > 250 ? `${course.courseDescription.substring(0, 250)}...` : course.courseDescription} position={course.courseDescription?.length > 30 ? "bottom" : "bottom-left"}>
                            <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap max-w-xs`}>{course.courseDescription}</p>
                          </Tooltip>
                          :
                          <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap max-w-xs`}>{course.courseDescription ? course.courseDescription : "--"}</p>
                        }
                      </div>
                      :
                      <div>
                        {course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ?
                          <p className={`${textResponsive("text-base")} font-semibold individual-course xl-mid:mb-2 xl-low:mb-1 mb-1 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus ? props.selectedCard === 3 ? "xl-low:w-[400px] w-[350px] xl-mid:w-[560px] xl-high:w-[400px]" : "xl-low:w-[210px] w-[210px] xl-mid:w-[300px] xl-high:w-[230px]" : "xl-low:w-[350px] w-[300px] xl-mid:w-[480px] xl-high:w-[400px]"} truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                            {course.courseName}
                          </p>
                          :
                          <Tooltip content={course.courseName} position="bottom-left">
                            <p className={`${textResponsive("text-base")} font-semibold individual-course xl-mid:mb-2 xl-low:mb-1 mb-1 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus ? props.selectedCard === 3 ? "xl-low:w-[400px] w-[350px] xl-mid:w-[560px] xl-high:w-[400px]" : "xl-low:w-[210px] w-[210px] xl-mid:w-[300px] xl-high:w-[230px]" : "xl-low:w-[350px] w-[300px] xl-mid:w-[480px] xl-high:w-[400px]"} truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                              {course.courseName}
                            </p>
                          </Tooltip>
                        }
                        {course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ?
                          <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap xl-high:mb-3 w-[150px] xl-low:w-[240px] xl-mid:w-[300px] xl-high:w-[230px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>
                            {course.courseDescription ? course.courseDescription : "--"}
                          </p>
                          :
                          course.courseDescription ?
                          <Tooltip content={course.courseDescription?.length > 250 ? `${course.courseDescription.substring(0, 250)}...` : course.courseDescription} position={course.courseDescription?.length > 30 ? "bottom" : "bottom-left"}>
                            <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap max-w-xs`}>{course.courseDescription ? course.courseDescription : "--"}</p>
                          </Tooltip>
                          :
                          <p className={`text-[#D0D0D0] ${textResponsive("text-sm")} font-semibold overflow-hidden text-ellipsis whitespace-nowrap max-w-xs`}>{course.courseDescription ? course.courseDescription : "--"}</p>
                        }
                      </div>
                    }
                  </div>
                  <div className="flex items-center">
                    {((course.inProgressStatus && props.selectedCard !== 3) || (props.selectedCard === 3 && (course.status === 2 || course.status === 4))) && (
                      <div className={`border mr-3 ${textResponsive("text-sm")} rounded-xl flex justify-center border-1.5 border-[#64C3FF] px-1 space-x-2 in-progress-key`}>
                        <img src="/progress.svg" alt="." />
                        <p className="text-[#64C3FF]">In-progress</p>
                      </div>
                    )}
                    {((course.failedStatus && props.selectedCard !== 3) || (props.selectedCard === 3 && course.status === 3)) && (
                      <div className={`border mr-3 ${textResponsive("text-sm")} rounded-xl flex justify-center items-center border-1.5 border-[#FF6464] px-2 space-x-2 failed-key`}>
                        <span className="w-2 h-2 bg-[#FF6464] rounded-full"></span>
                        <p className="text-[#FF6464]">Failed</p>
                      </div>
                    )}
                    <Checkbox 
                      data-testid={courseId} 
                      id={courseId} 
                      checked={props.selectedItems.includes(courseId)} 
                      className={`large-checkbox bg-[#202020] ${(course.inProgressStatus || isInactiveInstance) ? 'opacity-30 cursor-disable' : 'cursor-pointer'}`} 
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        if (course.inProgressStatus || isInactiveInstance) {
                          e.preventDefault();
                          return;
                        }
                        onItemSelect(courseId, e.target.checked);
                      }} 
                    />
                  </div>
                </div>

                {props.selectedCard !== 3 && (
                  <div className={`grid grid-cols-2 gap-4 mt-2 xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus ? "opacity-50" : ""}`}>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color`}>{VIEW_COURSE.STATE}</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] flex items-center`}>
                        <StatusBadge
                          className="mr-1 text-[8px] pt-1"
                          color={course.courseStage === 3 ? 'orange' : course.courseStage === 4 ? 'green' : (course.courseStage === 16 || course.courseStage === 17) ? 'gray' : course.failedStatus ? 'red' : course.inProgressStatus ? 'gray' : 'gray'}
                        />
                        {course.courseStage === 3 ? "Draft" : course.courseStage === 4 ? "Published" : (course.courseStage === 16 || course.courseStage === 17) ? "Deleting" : course.failedStatus ? "Failed" : course.inProgressStatus ? "In-progress" : "Unknown"}
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color`}>{VIEW_COURSE.LAST_MODIFIED_BY_LABEL}</div>
                      {course.inProgressStatus ?
                        <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] xl-high:w-[140px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>{course.lastModifiedBy}</div>
                        :
                        <Tooltip content={course.lastModifiedBy} position="bottom-left">
                          <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] xl-high:w-[140px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>{course.lastModifiedBy}</div>
                        </Tooltip>
                      }
                    </div>
                  </div>
                )}

                {props.selectedCard === 3 && (
                  <div className={`grid grid-cols-3 gap-4 mt-2 xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ? "opacity-50" : ""}`}>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color`}>{VIEW_COURSE.STATUS_LABEL}</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] flex items-center`}>
                        <StatusBadge
                          className="mr-1 text-[8px] pt-1"
                          color={course.status === 1 ? 'green' : course.status === 0 ? 'gray' : course.status === 2 ? 'gray' : course.status === 3 ? 'red' : course.status === 4 ? 'gray' : 'gray'}
                        />
                        {course.status === 1 ? "Active" : course.status === 0 ? "Expired" : course.status === 2 ? "In-progress" : course.status === 3 ? "Failed" : course.status === 4 ? "Deleting" : "Unknown"}
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[20px] label-color line-height-two`}>{VIEW_COURSE.LAST_MODIFIED_BY_LABEL}</div>
                      {course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ?
                        <div className={`${textResponsive("text-xs")} pt-1 ml-[20px] xl-high:w-[140px] truncate overflow-hidden text-ellipsis whitespace-nowrap line-height-half`}>{course.lastModifiedBy}</div>
                        :
                        <Tooltip content={course.lastModifiedBy} position="bottom-left">
                          <div className={`${textResponsive("text-xs")} pt-1 ml-[20px] xl-high:w-[140px] truncate overflow-hidden text-ellipsis whitespace-nowrap line-height-half`}>{course.lastModifiedBy}</div>
                        </Tooltip>
                      }
                    </div>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[20px] label-color`}>{VIEW_COURSE.DATE_TIME_LABEL}</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[20px] line-height-half`}>{formatDate(course.lastModifiedDate)}</div>
                    </div>
                  </div>
                )}

                {props.selectedCard !== 3 && (
                  <div className={`grid grid-cols-2 gap-4 mt-2 xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus ? "opacity-50" : ""}`}>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color line-height-two`}>{VIEW_COURSE.VAPP_TEMPLATE_NAME}</div>
                      {course.inProgressStatus ?
                        <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] xl:high-w-[210px] truncate overflow-hidden text-ellipsis whitespace-nowrap line-height-two`}>{course.vAppTemplateName}</div>
                        :
                        <Tooltip content={course.vAppTemplateName} position="bottom-left">
                          <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] xl:high-w-[210px] truncate overflow-hidden text-ellipsis whitespace-nowrap line-height-two`}>{course.vAppTemplateName}</div>
                        </Tooltip>
                      }
                    </div>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color`}>{VIEW_COURSE.DATE_TIME_LABEL}</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[30px] line-height-half`}>{formatDate(course.lastModifiedDate)}</div>
                    </div>
                  </div>
                )}

                {props.selectedCard === 3 && (
                  <div className={`grid grid-cols-3 gap-4 mt-2 xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ${course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ? "opacity-50" : ""}`}>
                    <div className="pt-2 col-span-2 course-template-associated">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[20px] label-color`}>{VIEW_COURSE.TEMPLATE_LABEL}</div>
                      {course.inProgressStatus || course.failedStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 3 || course.status === 4)) ?
                        <div className={`${textResponsive("text-xs")} pt-1 ml-[20px] xl:high-w-[300px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>{course.vAppTemplateName}</div>
                        :
                        <Tooltip content={course.vAppTemplateName} position="bottom-left">
                          <div className={`${textResponsive("text-xs")} pt-1 ml-[20px] xl:high-w-[300px] truncate overflow-hidden text-ellipsis whitespace-nowrap`}>{course.vAppTemplateName}</div>
                        </Tooltip>
                      }
                    </div>
                    <div className="pt-2">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[20px] label-color`}>Expiry Date</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[20px]`}>{moment(course.expiryData).format("M/D/YYYY")}</div>
                    </div>
                  </div>
                )}

                <div
                  className={`mt-2 w-[100%] ${course.inProgressStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 2 || course.status === 4)) ? "opacity-50" : ""} ${props.selectedCard === 3 ? "flex justify-between" : "flex justify-between items-center"}`}
                >
                  <div className={`pt-2 ${props.selectedCard === 3 ? "w-[70%]" : "w-[40%]"}`}>
                    <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[30px] label-color`}>{VIEW_COURSE.ACTIONS_LABEL}</div>
                    <div className="flex gap-3 mt-1 ml-[30px]">
                      {((props.selectedCard !== 3 && hasPermission(REQUIRED_PERMISSIONS.COURSE_LIBRARY_VIEW)) || (props.selectedCard === 3 && hasPermission(REQUIRED_PERMISSIONS.COURSE_INSTANCE_VIEW))) && (
                        <ButtonComponent
                        id={`view-course-${course.courseId}`}
                        data-testid={`view-course-${course.courseId}`}
                        aria-label="View"
                        tooltip="View"
                        className="border-0 rounded-none"
                        disabled={course.inProgressStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 14 || course.status === 2 || course.status === 4))}
                        iconButton={true}
                        onClick={() => {
                          if (props.selectedCard === 3 && course.courseId) {
                            navigate(`/academy/viewDeployedCourseInstance/${course.courseId}`);
                          } else if (course.courseId) {
                            navigate(`/academy/viewCourse/${course.courseId}`);
                          } else {
                            navigate("/academy/viewCourse");
                          }
                        }}
                        size="regular"
                        icon={<IconWrapper src={eyeIconImg} alt="" className={`${btnResponsive("text-base")}`} />}
                        iconPosition="left"
                        variant="tertiary"
                      />
                      )}
                      {([0, 1, 2, 3, 6, 13].includes(Number(course?.courseStage)) || (props.selectedCard === 3 && hasPermission(REQUIRED_PERMISSIONS.COURSE_INSTANCE_EDIT))) && !(props.selectedCard === 3 && course.status === 3) && (
                        <ButtonComponent
                          id={`edit-course-${course.courseId}`}
                          data-testid={`edit-course-${course.courseId}`}
                          aria-label="Edit"
                          tooltip="Edit"
                          className="border-0 rounded-none"
                          iconButton={true}
                          disabled={course.inProgressStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 14 || course.status === 2 || course.status === 4))}
                          onClick={() => props.selectedCard === 3 ? navigate("/academy/editCourseInstance/" + course.courseId.toString()) : navigate("/academy/editCourse/" + course.courseId.toString())}
                          size="regular"
                          icon={<IconWrapper src={editIconImg} alt="" className={`${btnResponsive("text-base")}`} />}
                          iconPosition="left"
                          variant="tertiary"
                        />
                      )}
                      {((props.selectedCard !== 3 && hasPermission(REQUIRED_PERMISSIONS.COURSE_LIBRARY_DELETE)) || (props.selectedCard === 3 && hasPermission(REQUIRED_PERMISSIONS.COURSE_INSTANCE_DELETE))) && (
                      <ButtonComponent
                        id={`delete-course-${course.courseId}`}
                        data-testid={`delete-course-${course.courseId}`}
                        aria-label="Delete"
                        tooltip="Delete"
                        className="border-0 rounded-none"
                        iconButton={true}
                        disabled={course.inProgressStatus || (props.selectedCard === 3 && (course.status === 0 || course.status === 14 || course.status === 2 || course.status === 4))}
                        onClick={() => handleDeleteClick(course?.courseId?.toString(), course)}
                        size="regular"
                        icon={<IconWrapper src={deleteIconImg} alt="" className={`${btnResponsive("text-base")}`} />}
                        iconPosition="left"
                        variant="tertiary"
                      />
                      )}
                    </div>
                  </div>
                  {course.courseStage === 4 && props.selectedCard !== 3 && (
                    <div className="pt-2">
                      {hasPermission(REQUIRED_PERMISSIONS.COURSE_INSTANCE_DEPLOY) && (
                        <Button
                          id={`deploy-instance-${course.courseId}`}
                          data-testid={`deploy-instance-${course.courseId}`}
                          className={`deploy-instance-button text-sm rounded text-xs h-[1.5rem] xl-low:!h-[2rem] xl-mid:!h-[2rem] xl-high:!h-[2.5rem]  xl-mid:!text-[20px] xl-high:!text-[20px]`}
                          disabled={course.inProgressStatus}
                          iconPosition="right"
                          variant="quiet-primary"
                          size="regular"
                          onClick={() => {
                            navigate("/academy/startCourseInstance", { state: { courseId: course.courseId } });
                          }}
                        >
                          {VIEW_COURSE.DEPLOY_COURSE_INSTANCES}
                        </Button>
                      )}
                    </div>
                  )}
                  <div></div>
                   {/* {props.selectedCard === 3 && (
                    <div className="pt-2 w-[30%]">
                      <div className={`${textResponsive("text-xs")} xl-low:mb-1 xl-mid:mb-2 xl-high:mb-3 ml-[15px] label-color`}>{VIEW_COURSE.EMAIL_SENT}</div>
                      <div className={`${textResponsive("text-xs")} pt-1 ml-[15px] flex items-center`}>
                        <StatusBadge
                          className="mr-1 text-[8px] pt-1"
                          color={course.isEmailSent === true ? 'green' : 'orange'}
                        />
                        {course.isEmailSent === true ? "Sent" : "Pending"}
                      </div>
                    </div>
                  )} */}
                </div>
                {showCopyCourseModal && (
                  <DuplicateCourse
                    isOpen={showCopyCourseModal}
                    courseId={modalcourseId}
                    onClose={handleCloseModal}
                  />
                )}
              </Card>
            )
          })}
        </div>
      </div>
      {showDeleteModal && (
        <Modal
          backdrop
          onModalClose={handleCloseDeleteModal}
          className="border border-[#E0E0E0] border-[0.2px]"
          title="Delete Course Template"
        >
          <div>
            <p className="mb-4">{VIEW_COURSE.DELETE.DELETE_COURSE_MESSAGE_LINE1} "{selectedCourse?.courseName}"? </p>
            <p>{VIEW_COURSE.DELETE.DELETE_COURSE_MESSAGE_LINE2}</p>
            <div className="flex gap-3 justify-end pt-4">
              <Button
                variant="secondary"
                size="regular"
                onClick={handleCloseDeleteModal}
              >
                {VIEW_COURSE.DELETE.CANCEL}
              </Button>
              <Button
                variant="primary"
                size="regular"
                onClick={handleDeleteCourse}
              >
                {VIEW_COURSE.DELETE.DELETE_ANYWAY}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete Course Instance Confirmation Modal */}
      {showCourseInstanceDeleteModal && (
        <Modal
          backdrop
          onModalClose={handleDeleteCancel}
          className="border border-[#E0E0E0] border-[0.2px]"
          title="Delete Deployed Course"
        >
          <div>
            <div className="text-sm text-white-700 mb-1 text-left">{VIEW_COURSE.DELETE.DELETE_INSTANCE_MESSAGE_LINE1} "{selectedCourse?.courseName}", </div>
            <div className="text-sm text-white-700 mb-3 text-left">{VIEW_COURSE.DELETE.DELETE_INSTANCE_MESSAGE_LINE2}</div>
            <div className="text-sm text-white-700 mb-6 text-left">"{selectedCourse?.vAppTemplateName}"</div>
            <div className="text-sm text-white-700 mb-12 text-left">{VIEW_COURSE.DELETE.DELETE_INSTANCE_MESSAGE_LINE3}</div>
            <div className="flex justify-center gap-4">
              <Button
                id="cancel-delete-instance"
                data-testid="cancel-delete-instance"
                variant="secondary"
                size="regular"
                onClick={handleDeleteCancel}
                className="min-w-[160px] text-sm font-normal"
              >
                {VIEW_COURSE.DELETE.CANCEL}
              </Button>
              <Button
                id="force-delete-instance"
                data-testid="force-delete-instance"
                variant="primary"
                size="regular"
                onClick={handleCourseInstanceDeleteConfirm}
                className="min-w-[160px] text-sm font-normal"
              >
                {VIEW_COURSE.DELETE.FORCE_DELETE}
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ViewCourseDetail;